export default __webpack_public_path__ + "excel.67f98fb192f5295880211ac91622a50a.png";